/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum WalletStatusEnum {
  "VALIDATED" = "VALIDATED"
}

/**
 * Enumeration of wallet statuses
 */

export type WalletStatus = t.TypeOf<typeof WalletStatus>;
export const WalletStatus = enumType<WalletStatusEnum>(
  WalletStatusEnum,
  "WalletStatus"
);
